/**
 * 게시판 글 작성/수정 폼 — $j.F.Admin.BoardPostForm (정적 모듈, 옛 public/js/a-board-edit.js)
 *
 * 폼 마크업은 adm/pages/board/_post-edit-body.blade.php 하나다. 두 화면이 쓴다:
 *   글 관리(/adm/board/{code}) 우측 패널 — partial 을 ajax 로 받아 넣은 뒤 init
 *   단독 편집(/adm/board/{code}/post/…)   — 페이지 모듈이 init
 *
 *   $j.F.Admin.BoardPostForm.init({ onSaved(num), onDeleted(num) })  // 폼이 DOM 에 들어간 직후
 *   $j.F.Admin.BoardPostForm.destroy()                               // 다른 폼으로 바꾸기 전 (CKEditor 정리)
 *
 * 폼 데이터(게시판·글번호·본문·소속표·대상)는 partial 안의 JSON 블록 .board-post-data 에서 읽는다.
 * 콜백이 없으면 저장·삭제 뒤 그 게시판 목록으로 간다(단독 화면).
 * data 구조: { board_code, post_id, body, sosok:{bonsa,gisa}, targets:{bonsa,gisa,mtype,ctype} }
 */
// 모듈 상태 (단일 인스턴스만 유지)
const M = {
    boardCode: null,
    postId:    null,
    editor:    null,
    isHtmlMode: false,
    newAttachFiles: [],
    sosokDict: { bonsa: {}, gisa: {} },
    memberTypes: ['수발주자','업체발주자','발주자'],
};

function initBoardPostForm(data){
    // 이전 인스턴스 정리
    if (M.editor || M.postId !== null || M.boardCode !== null) {
        destroyBoardPostForm();
    }

    M.boardCode = data.board_code;
    M.postId    = data.post_id || null;
    M.isHtmlMode = false;
    M.newAttachFiles.length = 0;
    M.sosokDict = data.sosok || { bonsa:{}, gisa:{} };

    // 팝업 기간 datepicker — 날짜 + 시각(분). 인풋 값은 'YYYY-MM-DD HH:mm' 이 되고,
    // 시각을 안 적은 기존 값(날짜만)도 서버가 그날 전체로 읽는다 (BoardPostWriteService::toDateTime).
    // 시각 휠이 있으면 날짜를 고른 순간 닫혀선 안 되므로 확인 버튼을 둔다.
    $('#f_popup_start,#f_popup_end').mobiscroll().datepicker({
        controls: ['calendar', 'time'],
        dateFormat: 'YYYY-MM-DD',
        timeFormat: 'HH:mm',
        locale: mobiscroll.localeKo,
        buttons: ['cancel', 'set'],
    });
    $('#f_is_popup').on('change.boardForm', refreshPopupEnable).trigger('change.boardForm');

    // chip 4개 초기화
    initChips(data.targets || {});

    // 내용 잠금 — 약관 개정 회차 공지 등(content_locked=1). 노출 설정만 변경 가능.
    M.locked = $('.board-post-form').data('locked') == 1;

    // CKEditor 5
    initEditor(data.body || '');

    // 첨부 핸들러 (잠금 시 파일 선택 비활성화)
    $('#f_cover').on('change.boardForm', onCoverChange);
    $('#f_attachments').on('change.boardForm', onAttachmentsChange);
    if (M.locked) {
        $('#f_cover, #f_attachments').prop('disabled', true);
        $('#toggleHtmlBtn').hide();
    }

    // 갤러리 — 클릭 위임 + 진입 시 자동
    initGallery();

    // 폼 안의 버튼 — data-bpf="동작". 지우기(×)는 썸네일 클릭(갤러리)보다 먼저 받아 전파를 끊는다
    $('.board-post-form')
        .on('click.boardForm', '[data-bpf]', function(e){
            const a = this.dataset.bpf;
            if (a === 'save') savePost();
            else if (a === 'delete') deletePost();
            else if (a === 'toggleHtml') toggleHtmlMode();
            else if (a === 'removeCover') { e.stopPropagation(); removeCover(); }
            else if (a === 'removeAttach') { e.stopPropagation(); removeAttach(Number(this.dataset.idx)); }
            else if (a === 'removeChip') removeChip(this.dataset.w, this.dataset.code);
        });
}

function destroyBoardPostForm(){
    // CKEditor destroy
    if (M.editor) {
        try { M.editor.destroy().catch(()=>{}); } catch(e) {}
        M.editor = null;
    }
    // mobiscroll destroy
    try { $('#f_popup_start,#f_popup_end').mobiscroll('destroy'); } catch(e) {}

    // 이벤트 detach
    $('.board-post-form').off('.boardForm');
    $('#f_is_popup,#f_cover,#f_attachments').off('.boardForm');
    $('#cover_preview, #attach_preview').off('.boardForm');
    ['bonsa','gisa','mtype','ctype'].forEach(w => $(`#add_${w}`).off('.boardForm'));


    M.newAttachFiles.length = 0;
    M.boardCode = null;
    M.postId = null;
}

function refreshPopupEnable(){
    const on = $('#f_is_popup').is(':checked');
    $('#f_popup_start,#f_popup_end').prop('disabled', !on).css('background', on?'':'#eee');
    $('#f_popup_odr').prop('disabled', !on).css('background', on?'':'#eee');
    // 팝업 닫기 옵션·순서·기간 안내는 팝업노출 켜졌을 때만 의미가 있으므로 그때만 노출
    $('#popup_dismiss_row, #popup_period_hint, #popup_odr_box').toggle(on);
}

// ── chip-multiselect ──
function initChips(initTargets){
    setupChip('bonsa', M.sosokDict.bonsa, initTargets.bonsa || []);
    setupChip('gisa',  M.sosokDict.gisa,  initTargets.gisa  || []);
    const m = {}; M.memberTypes.forEach(v => m[v]=v);
    const c = {}; (typeof G5 !== 'undefined' && G5['CARTYPE_KR'] || []).forEach(v => c[v]=v);
    setupChip('mtype', m, initTargets.mtype || []);
    setupChip('ctype', c, initTargets.ctype || []);
}
function setupChip(wId, dict, initCodes){
    const $sel  = $(`#picker_${wId}`);
    const $chips= $(`#chips_${wId}`);
    $sel.empty().append('<option value="">선택</option>');
    Object.keys(dict).forEach(code => {
        $sel.append(`<option value="${escAttr(code)}">${escHtml(dict[code])}</option>`);
    });
    $chips.empty();
    (initCodes||[]).forEach(code => addChip(wId, code, dict[code] || code));
    $(`#add_${wId}`).off('.boardForm').on('click.boardForm', function(){
        const code = $sel.val();
        if (!code) return;
        if ($chips.find(`[data-code="${cssEsc(code)}"]`).length) return;
        addChip(wId, code, dict[code] || code);
        $sel.val('');
        updateChipEmpty(wId);
    });
    updateChipEmpty(wId);
}
function addChip(wId, code, label){
    const $chips = $(`#chips_${wId}`);
    $chips.find('.chip-empty').remove();
    $chips.append(
        `<span class="chip" data-code="${escAttr(code)}">${escHtml(label)}` +
        `<span class="close" data-bpf="removeChip" data-w="${wId}" data-code="${escAttr(code)}">×</span></span>`
    );
}
function removeChip(wId, code){
    $(`#chips_${wId} .chip[data-code="${cssEsc(code)}"]`).remove();
    updateChipEmpty(wId);
}
function updateChipEmpty(wId){
    const $chips = $(`#chips_${wId}`);
    if (!$chips.find('.chip').length) {
        $chips.html('<span class="chip-empty">(전체 대상 — 비어있음)</span>');
    }
}
function collectChipCodes(wId){
    return $(`#chips_${wId} .chip`).map((_, el) => $(el).data('code')).get();
}

// ── CKEditor 5 ──
function initEditor(initialBody){
    DecoupledEditor
        .create(document.querySelector('#editor'), {
            toolbar: ['heading','|','fontSize','fontFamily','|','fontColor','fontBackgroundColor','|','bold','italic','strikethrough','underline','|','alignment','|','indent','outdent','|','link','blockQuote','insertTable','|','undo','redo'],
            language: 'ko'
        })
        .then(ed => {
            M.editor = ed;
            document.querySelector('.toolbar-container').appendChild(ed.ui.view.toolbar.element);
            if (initialBody) ed.setData(initialBody);
            if (M.locked) ed.enableReadOnlyMode('content-locked');   // 잠긴 글은 본문 편집 불가
        })
        .catch(e => console.error(e));
}
// HTML 소스칸은 .form-control(block) 이라 show() 대신 클래스로 연다 — show() 는 textarea 기본값(inline-block)으로 띄운다
function toggleHtmlMode(){
    if (!M.isHtmlMode) {
        $('#htmlEditor').val(M.editor ? M.editor.getData() : '');
        $('#editor,.toolbar-container').hide();
        $('#htmlEditor').removeClass('bp-html-off');
        $('#toggleHtmlBtn').text('에디터 편집');
        M.isHtmlMode = true;
    } else {
        if (M.editor) M.editor.setData($('#htmlEditor').val());
        $('#htmlEditor').addClass('bp-html-off');
        $('#editor,.toolbar-container').show();
        $('#toggleHtmlBtn').text('HTML 편집');
        M.isHtmlMode = false;
    }
}

// ── 첨부 핸들러 ──
function onCoverChange(){
    const f = this.files[0];
    if (!f) return;
    const url = URL.createObjectURL(f);
    $('#cover_preview').html(
        `<div class="file-thumb is-zoom" data-gallery-src="${url}" style="--thumb:url('${url}')">
            <span class="rm" data-bpf="removeCover">×</span>
            <span class="label">대표 (신규)</span>
         </div>`
    );
    $('#f_cover_keep').val('1');
}
function removeCover(){
    $('#cover_preview').empty();
    $('#f_cover').val('');
    $('#f_cover_keep').val('0');
}

function onAttachmentsChange(){
    Array.from(this.files).forEach(f => {
        const idx = M.newAttachFiles.length;
        M.newAttachFiles.push(f);
        const url = URL.createObjectURL(f);
        $('#attach_preview').append(
            `<div class="file-thumb is-zoom" data-attach-idx="${idx}" data-gallery-src="${url}" style="--thumb:url('${url}')">
                <span class="rm" data-bpf="removeAttach" data-idx="${idx}">×</span>
            </div>`
        );
    });
    this.value = '';
}
function removeAttach(idx){
    M.newAttachFiles[idx] = null;
    $(`#attach_preview [data-attach-idx="${idx}"]`).remove();
}

// ── 갤러리 모달 ──
function initGallery(){
    // 썸네일 클릭 → 모달. 자동 표시는 하지 않는다 (UX: 모달 강제 노출 방지).
    $('#cover_preview, #attach_preview').on('click.boardForm', '.file-thumb[data-gallery-src]', function(e){
        if ($(e.target).closest('.rm').length) return;   // 지우기(×)는 폼 위임(data-bpf)이 받는다
        openGalleryAt($(this).attr('data-gallery-src'));
    });
    // 깨진 이미지 검출
    checkBrokenThumbs();
}

// 기존 첨부의 background-image 가 fail 일 때 .broken 클래스로 placeholder 표시.
// blob: URL (신규 업로드 미리보기) 은 항상 로드 성공이므로 skip.
function checkBrokenThumbs(){
    $('#cover_preview .file-thumb[data-gallery-src], #attach_preview .file-thumb[data-gallery-src]').each(function(){
        const $el = $(this);
        const src = $el.attr('data-gallery-src');
        if (!src || src.startsWith('blob:')) return;
        const im = new Image();
        im.onload  = () => $el.removeClass('broken');
        im.onerror = () => $el.addClass('broken');
        im.src = src;
    });
}
function collectGallerySrcs(){
    return $('#cover_preview .file-thumb[data-gallery-src], #attach_preview .file-thumb[data-gallery-src]')
        .map((_, el) => $(el).attr('data-gallery-src')).get();
}
function openGalleryAt(clickedSrc){
    const srcs = collectGallerySrcs();
    if (!srcs.length) return;
    const idx = Math.max(0, srcs.indexOf(clickedSrc));
    $j.Ui.ZoomPhoto.open(null, {
        items: srcs.map(url => ({ url })),
        index: idx,
    });
}

// ── 저장 / 삭제 ──
function savePost(){
    const title = $('#f_title').val().trim();
    if (!title) { alert('제목을 입력해 주세요.'); $('#f_title').focus(); return; }
    const body = M.isHtmlMode ? $('#htmlEditor').val() : (M.editor ? M.editor.getData() : '');

    const fd = new FormData();
    if (M.postId) fd.append('num', M.postId);
    fd.append('board_code',  M.boardCode);
    fd.append('category',    $('#f_category').val());
    fd.append('title',       title);
    fd.append('body',        body);
    fd.append('pinned',      $('#f_pinned').is(':checked') ? 1 : 0);
    fd.append('is_hidden',   $('#f_is_hidden').is(':checked') ? 1 : 0);
    fd.append('is_popup',    $('#f_is_popup').is(':checked') ? 1 : 0);
    fd.append('is_ad',       $('#f_is_ad').is(':checked') ? 1 : 0);   // 광고성 — 푸시는 광고 수신 동의자에게만, 제목 앞 (광고)
    fd.append('popup_start', $('#f_popup_start').val());
    fd.append('popup_end',   $('#f_popup_end').val());
    fd.append('popup_odr',   $('#f_popup_odr').val() || 0);
    fd.append('popup_dismiss',      1);   // '다시 보지 않기'는 항상 표시 — 방식만 관리자가 선택
    fd.append('popup_dismiss_mode', $('#f_popup_dismiss_mode').val());
    ['bonsa','gisa','mtype','ctype'].forEach(w => {
        collectChipCodes(w).forEach(c => fd.append(`targets[${w}][]`, c));
    });
    const cover = $('#f_cover')[0].files[0];
    if (cover) fd.append('cover_file', cover);
    fd.append('cover_keep', $('#f_cover_keep').val());
    M.newAttachFiles.forEach(f => { if (f) fd.append('attachments[]', f); });

    $.ajax({
        url: '/adm/ajax/board/post/save',
        type: 'POST',
        data: fd,
        processData: false,
        contentType: false,
        success: function(res){
            if (res && res.result) {
                if (typeof M.onSaved === 'function') {
                    M.onSaved(res.num);
                } else {
                    alert(res.message || '저장되었습니다.');
                    location.href = `/adm/board/${M.boardCode}`;
                }
            } else {
                alert((res && res.message) || '저장에 실패했습니다.');
            }
        },
        error: function(){ alert('저장 요청에 실패했습니다.'); }
    });
}

function deletePost(){
    if (!M.postId) return;
    if (!confirm('이 글을 삭제할까요?')) return;
    const deletedId = M.postId;
    $.post('/adm/ajax/board/post/delete', { num: deletedId }, function(res){
        if (res && res.result) {
            if (typeof M.onDeleted === 'function') {
                M.onDeleted(deletedId);
            } else {
                location.href = `/adm/board/${M.boardCode}`;
            }
        } else {
            alert((res && res.message) || '삭제에 실패했습니다.');
        }
    });
}

function escHtml(s){ return String(s==null?'':s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
function escAttr(s){ return escHtml(s); }
function cssEsc(s){ return String(s).replace(/(["\\])/g,'\\$1'); }

export default class BoardPostForm {
    static init(opts = {}) {
        const el = document.querySelector('.board-post-form .board-post-data, .board-post-data');
        const data = el ? JSON.parse(el.textContent) : {};
        initBoardPostForm(data);
        M.onSaved   = opts.onSaved || null;
        M.onDeleted = opts.onDeleted || null;
    }

    static destroy() {
        destroyBoardPostForm();
    }
}
